export const operationsTableHeader = [
  "Employee Name",
  "Dr. ID",
  // "Clinic Id",
  "Dr. Name",
  "Training Date",
  "Start Time",
  "End Time",
  "Remarks",
  "Status",
  "History",
  "Actions",
];

export const addNewOperationsTableHeader = [
  "Dr. ID",
  "Clinic Id",
  "Dr. Name",
  "Clinic Role",
  "Clinic Name",
  "Total Appointments",
  "Last Appointment",
  "Total Prescriptions",
  "Last Prescription Date",
  "Actions",
];

export const renewalTableHeader = [
  "Employee Name",
  "Dr. ID",
  "Clinic Id",
  "Dr. Name",
  // "City",
  "Call Date",
  "Quotation",
  "Remarks",
  "Conversion",
  "History",
  "Actions",
];

export const customerCareTableHeader = [
  "Employee Name",
  "Dr. ID",
  "Ticket Id",
  // "Clinic Id",
  "Dr. Name",
  "Contact",
  // "City",
  // "Email",
  "Issue Date",
  // "Start Time",
  // "End Time",
  // "Time",
  "Remarks",
  "Status",
  "History",
  "Actions",
];

export const customerCareTimeLineHeader = [
  "Issues Date",
  "Issue Resolved By",
  "Remarks",
];

export const OperationsTimeLineHeader = [
  "Training Date",
  "Training Done By",
  "Remarks",
];

export const RenewalTimeLineHeader = [
  "Renewal Quotation Date",
  "Quotation Sent by",
  "Remarks",
];
